import axios from 'axios'
import api from './api'
let http_count = ref(0)

let _loading = ref<LoadingObj>({
  // loading服务调用赋值对象
  serviceObj: null,
  // loading 配置参数
  options: {
    lock: true,
    text: '加载中...',
    // spinner: '<Loading />',
    background: 'rgba(0, 0, 0, 0.7)',
  },
  // 是否开启loading遮罩
  open: false,
})

/**
 * 提示函数
 * 禁止点击蒙层，显示一秒后关闭
 * @param {String} msg 提示文字
 */
const _show_tip = function (msg: string) {
  ElMessage({
    message: msg,
    duration: 2000,
    showClose: true,
    type: 'error',
    offset: 100, // 距离顶部100px
  })
}

// 创建axios实例
let instance = axios.create({})

//设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  async (config) => {
    // 判断是否开启loading遮罩
    _loading.value.open && (_loading.value.serviceObj = ElLoading.service(_loading.value.options))
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    return config
  },
  (error) => {
    http_count.value -= 1
    Promise.resolve({
      state: false,
      msg: error,
    })
  },
)

/**
 * 响应拦截器
 */
instance.interceptors.response.use(
  // 请求成功
  (res: any) => {
    //有code字段
    http_count.value -= 1
    let code = res.data.code
    let locObj = res.config.headers.locObj
    locObj = JSON.parse(locObj)
    if (code == 305 && !locObj.noMind) {
      closeLoading()
      //登录失效
      ElMessageBox.alert(res.data.msg || '登录失效，请重新登录', '登录过期提示', {
        showClose: false,
        type: 'warning',
        callback: () => {
          //清除登录状态
          Cookies.remove('loginUserId')
          router.push('/login')
        },
      })
      return Promise.reject(res.data)
    }
    if (code != 0 && !locObj.noMind) {
      //请求错误
      _show_tip(res.data.msg || '请求异常，请刷新或稍后重试!')
    }
    // 判断是否开启loading遮罩
    closeLoading()
    if (code != 0) {
      return Promise.reject(res.data)
    }
    return res.data
  },
  // 请求失败
  (error) => {
    http_count.value -= 1
    closeLoading()
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      _show_tip('网络错误，请稍后重试!')
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        // 断网情况
        _show_tip('网络错误，请稍后重试!')
      } else {
        if (axios.isCancel(error)) {
          return new Promise(() => {})
        }
        _show_tip('网络错误，请稍后重试!')
        return Promise.reject(error)
      }
    }
  },
)
// 检查是否开启加载动画
function checkLoading(loading: boolean, loadingText?: string) {
  loading ? (_loading.value.open = true) : (_loading.value.open = false)
  loadingText ? (_loading.value.options.text = loadingText) : '加载中...'
}
//关闭加载动画
function closeLoading() {
  //仍有请求进行中时，不关闭加载动画，等全部请求完成后才关闭
  if (http_count.value == 0) {
    _loading.value.open && _loading.value.serviceObj.close()
    _loading.value.open = false
  }
}

/**
 * 资源请求对象
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Boolean} noMind 请求返回code非0是否自动提示错误信息，默认开启（false：自动提示，true：不自动提示）
 * @param {Boolean} loading 是否开启loading遮罩，默认开启（false：关闭，true：开启）
 * @param {String} loadingText loading显示文字（默认显示“加载中...”）
 */
const $http = {
  get: async ({ url, params, loading = true, loadingText, noMind = false }: HtppOption) => {
    let request_url = api[url]
    if (!request_url) {
      _show_tip('请求发送失败，未知的请求地址')
      return Promise.reject()
    }
    checkLoading(loading, loadingText)
    let tempParams = params || {}
    http_count.value += 1
    return instance.get(request_url, {
      params: tempParams,
      headers: {
        locObj: JSON.stringify({ loading: loading, noMind: noMind }),
      },
    })
  },
  post: async ({ url, params, loading = true, loadingText, noMind = false }: HtppOption) => {
    let request_url = api[url]
    if (!request_url) {
      _show_tip('请求发送失败，未知的请求地址')
      return Promise.reject()
    }
    checkLoading(loading, loadingText)
    http_count.value += 1
    let tempParams = params || {}
    return instance.post(request_url, tempParams, {
      headers: {
        locObj: JSON.stringify({ loading: loading, noMind: noMind }),
      },
    })
  },
}
export default $http
